import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { EventBusService } from "../../../../services/event-bus.service";
import { TouristsComponent } from "../tourists/tourists.component";
import { ShortSearchDatesDropdownComponent } from "./dates-dropdown/short-search-dates-dropdown.component";
import { ShortSearchNightsDropdownComponent } from "./nights-dropdown/short-search-nights-dropdown.component";
import { ShortSearchParamsFacade } from "../short-search-params.facade";

@Component({
  selector: "app-short-search-params-desktop",
  templateUrl: "./short-search-params-desktop.component.html",
  styleUrls: ["./short-search-params-desktop.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TouristsComponent, ShortSearchDatesDropdownComponent, ShortSearchNightsDropdownComponent],
})
export class ShortSearchParamsDesktopComponent implements OnInit, OnDestroy {
  openedDropdown: "departureCity" | "dates" | "checkOut" | "nights" | "tourists" | null = null;
  private subscription?: Subscription;
  private emptyCalendarSubscription?: Subscription;

  constructor(
    public facade: ShortSearchParamsFacade,
    private cdRef: ChangeDetectorRef,
    private eventBusService: EventBusService,
  ) {}

  ngOnInit() {
    this.emptyCalendarSubscription = this.eventBusService.openCalendarFromEmptyResult$.subscribe(() => {
      if (this.facade.isHotelsSearch) {
        this.openedDropdown = 'dates';
        this.facade.openDesktopDates('checkIn');
        this.cdRef.detectChanges();
      }
    });
    this.subscription = this.facade.viewStateChanged$.subscribe(() => {
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.emptyCalendarSubscription?.unsubscribe();
  }

  @HostListener("document:click")
  closeDropdownOnOutsideClick() {
    if (this.openedDropdown) {
      this.openedDropdown = null;
      this.facade.resetNightRangePreview();
      this.cdRef.detectChanges();
    }
  }

  toggleDropdown(key: "departureCity" | "dates" | "checkOut" | "nights" | "tourists", event: MouseEvent) {
    event.stopPropagation();
    this.openedDropdown = this.openedDropdown === key ? null : key;

    if (this.openedDropdown === "dates") {
      this.facade.openDesktopDates("checkIn");
    }

    if (this.openedDropdown === "checkOut") {
      this.facade.openDesktopDates("checkOut");
    }

    if (this.openedDropdown !== "nights") {
      this.facade.resetNightRangePreview();
    }

    this.cdRef.detectChanges();
  }

  selectDepartureCity(cityId: number) {
    this.facade.selectDepartureCity(cityId);
    this.openedDropdown = null;
    this.cdRef.detectChanges();
  }

  selectNights(day: number) {
    const shouldClose = this.facade.selectNights(day);

    if (shouldClose) {
      this.openedDropdown = null;
      this.facade.resetNightRangePreview();
    }

    this.cdRef.detectChanges();
  }

  onDateSelected(key: string) {
    this.facade.selectDate(key);

    if (!this.facade.isHotelsSearch) {
      this.cdRef.detectChanges();
      return;
    }

    if (this.openedDropdown === "dates") {
      setTimeout(() => {
        this.openedDropdown = "checkOut";
        this.facade.openDesktopDates("checkOut");
        this.cdRef.detectChanges();
      });
      return;
    }

    if (this.openedDropdown === "checkOut") {
      this.openedDropdown = null;
      this.cdRef.detectChanges();
      return;
    }

    this.cdRef.detectChanges();
  }

  onApply() {
    this.facade.apply();
  }
}
